import { DRIFT_SENTRY_CONFIG_DEFAULT } from 'shared/constants/logging'
import { broadcast } from 'utils/message'
import { createReducer } from 'utils/redux'

const defaultState = {
  sentryConfig: DRIFT_SENTRY_CONFIG_DEFAULT
}

const receiveSentryConfig = ({action, draft})=>{
  draft.sentryConfig = action.payload

  // set in conductor too
  broadcast({
    topic:'set-value-on-host-window',
    message:{
      key: 'drift_sentry_config',
      value: action.payload
    }
  })
}

export default createReducer(
  defaultState,
  {
    RECEIVE_SENTRY_CONFIG: receiveSentryConfig
  }
)
